module.exports = __webpack_public_path__ + "img/activity.6f4d2d94.svg";